import * as serverApi from './server';

export const addStock = (payload) => serverApi.post('/stocks', payload);
export const getStocks = (payload) => serverApi.get('/stocks', payload);
export const getStockById = ({ stockId, ...payload }) =>
  serverApi.get(`/stocks/${stockId}`, payload);
export const updateStocks = ({ stockId, ...payload }) =>
  serverApi.put(`/stocks/${stockId}`, payload);
export const getUsersEligibleToAddStock = (payload) =>
  serverApi.get('/users/stock-eligibility', payload);
export const stockCSVExports = (payload) => serverApi.get('/stocks/csv-exports', payload);
export const updateStockChangeLog = ({ stockId, ...payload }) =>
  serverApi.put(`/stocks/${stockId}/change-logs`, payload);
export const stockChangeLogsCSVExports = ({ stockId, ...payload }) =>
  serverApi.get(`/stocks/${stockId}/change-logs/csv-exports`, payload);
export const stockBatchNameList = (payload) => serverApi.get('/stocks/batch-list', payload);
